module.exports = __webpack_public_path__ + "43a9e67b173037d6c619c48c45444be8.svg";